import React from "react";
import { Paper, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles({
  paper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    padding: 16,
    background: "transparent",
    height: 300,
    borderRadius: 12,
    transition: "box-shadow 500ms ease, transform 500ms ease",
    "&:hover": {
      transform: "scale(1.05)",
      boxShadow: "0 0 50px 0 rgba(175, 175, 175, 0.4)",
      background: "white"
    }
  },
  title: {
    fontSize: 18,
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal"
  }
});

export default function BenefitCard({ title, icon, description }) {
  const classes = useStyles();
  return (
    <Paper elevation={0} className={classes.paper}>
      <img src={`/images/${icon}`} />
      <br />
      <Typography variant="h6" className={classes.title}>
        {title}
      </Typography>
      <br />
      <Typography variant="body1">{description}</Typography>
    </Paper>
  );
}
